import { render, staticRenderFns } from "./ResourcesWrapper.vue?vue&type=template&id=a68fc096&scoped=true&"
import script from "./ResourcesWrapper.vue?vue&type=script&lang=ts&"
export * from "./ResourcesWrapper.vue?vue&type=script&lang=ts&"
import style0 from "./ResourcesWrapper.vue?vue&type=style&index=0&id=a68fc096&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a68fc096",
  null
  
)

export default component.exports